/**
 * Archivo de configuración de la interfaz con Firebase. Exporta las funciones y contextos que
 * se requiren para interactuar con Firebase. Debe usarse como única fuente de métodos de
 * interacción con Firebase, para limitar los imports de funciones de firebase con controladas
**/

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged,
  createUserWithEmailAndPassword, signInWithEmailAndPassword, setPersistence,
  browserSessionPersistence,
} from "firebase/auth"
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { FacebookAuthProvider, OAuthProvider } from "firebase/auth/web-extension";

//Datos de API a firebase del proyecto Creator-mixreal-aee15. Necesarios para poder hacer
//peticiones
const firebaseConfig = {
  apiKey: "AIzaSyDYHS7aUSlzZcA4_q4oM0FN_vAyVROoP2o",
  authDomain: "creator-mixreal-aee15.firebaseapp.com",
  databaseURL: "https://creator-mixreal-aee15-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "creator-mixreal-aee15",
  storageBucket: "creator-mixreal-aee15.firebasestorage.app",
  messagingSenderId: "146213692063",
  appId: "1:146213692063:web:751c686e9fd31fc405f8aa",
  measurementId: "G-EKYY856BR2"
};

//Se inicializa la API
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app); //objeto de interacción con Storage
const db = getFirestore(app); //objeto de interacción con Firestore
//objetos de interacción con autenticadores de terceros
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
const microsofProvider = new OAuthProvider("microsoft.com");

//se exportan los métodos y objetos con los que se desea interactuar en la app React
export { auth, storage, db, googleProvider, facebookProvider, microsofProvider, signInWithPopup,
  signOut, onAuthStateChanged, createUserWithEmailAndPassword, signInWithEmailAndPassword,
  setPersistence, browserSessionPersistence };